import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import { palette } from '../utils/designTokens';

/**
 * CopyButton - Reusable button for copying text to clipboard
 *
 * @param {string} text - Text to copy
 * @param {string} size - Icon size ('xs', 'sm', 'md') - default 'sm'
 * @param {string} label - Accessible label for screen readers
 */
const CopyButton = ({ text, size = 'sm', label = 'Copy to clipboard' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation(); // Prevent event bubbling

    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const iconSizes = {
    xs: 12,
    sm: 14,
    md: 16
  };

  const iconSize = iconSizes[size] || iconSizes.sm;

  return (
    <button
      onClick={handleCopy}
      className="inline-flex items-center justify-center transition-colors hover:opacity-70"
      style={{
        color: copied ? palette.status.success : palette.text.secondary,
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '2px'
      }}
      title={copied ? 'Copied!' : label}
      aria-label={label}
    >
      {copied ? (
        <Check size={iconSize} strokeWidth={2} />
      ) : (
        <Copy size={iconSize} strokeWidth={1.5} />
      )}
    </button>
  );
};

export default CopyButton;
